<!--
 * @Author: your name
 * @Date: 2021-06-23 14:32:54
 * @LastEditTime: 2021-07-07 11:57:36
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\components\skillarea.vue
-->
<template>
  <div class="skillarea" v-if="isshow">
    <div class="skill_title">
      <img src="@assets/images/skill_title.png" alt="" />
      <div class="content">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in timeList" :key="index">
            <p>{{ item.time }}</p>
            <div>{{ item.status }}</div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "skillarea",
  components: {
    swiper,
    swiperSlide
  },
  created() {},
  props: {
    timeList: {
      type: Array,
      default: () => []
    },
    goodslist: {
      type: Array,
      default: () => []
    },
    isshow: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  data() {
    return {
      swiperOption: {
        observer: true,
        observeParents: true,
        slidesPerView: 4
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.skillarea {
  width: 100vw;
  .skill_title {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>
